import { Vue, Component, Prop } from 'vue-property-decorator'
import ProductDetailProperty from '~/types/api/ProductDetailProperty'
import ArrowSvg from '~/assets/svg/product-arrow.svg?inline'
import ArrowNavSvg from '~/assets/svg/arrow-search.svg?inline'

@Component
export default class ProductInstruction extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: ProductDetailProperty[]

  currentInstructionIndex: number = 0

  selected: string | null = null

  scrollTo (index: number) {
    if (index < 0 || index >= this.propertyList.length) {
      return
    }
    const elem = document.querySelectorAll('.product-page-instruction__item')[index]
    if (elem) {
      const offset = window.scrollY + elem.getBoundingClientRect().top - window.innerHeight / 4
      window.scroll({ top: offset, left: 0, behavior: 'smooth' })
      this.currentInstructionIndex = index
    }
  }

  scrollToToggle (index: number) {
    if (index < 0 || index >= this.propertyList.length) {
      return
    }
    const container = document.querySelectorAll('.product-page-instruction__col-content')[0]
    if (container) {
      const offset = container.getBoundingClientRect().top + window.pageYOffset - 10
      window.scroll({ top: offset, left: 0, behavior: 'smooth' })
      this.currentInstructionIndex = index
    }
  }

  get propertyList (): ProductDetailProperty[] {
    return this.items.filter(e => e.html !== null)
  }

  toggle (code: string) {
    if (code === this.selected) {
      this.selected = null
    } else {
      this.selected = code
    }
  }

  renderItem (item: ProductDetailProperty, index: number) {
    return (
      <div key={item.code} {...{
        class: {
          'product-page-instruction__item': true,
          'product-page-instruction__item_selected': item.code === this.selected
        }
      }}>
        <div class="product-page-instruction__title-wrapper" onClick={() => {
          this.scrollToToggle(index)
          setTimeout(() => {
            this.toggle(item.code)
          }, 500)
        }}>
          <h3 class="product-page-instruction__title">
            {item.title}
          </h3>
          <div class="product-page-instruction__arrow">
            <ArrowSvg />
          </div>
        </div>
        <div class="product-page-instruction__content custom-content" domPropsInnerHTML={item.html}></div>
      </div>
    )
  }

  renderNavigation () {
    return (
      <div class="product-page-instruction__nav-wrapper">
        <div class="product-page-instruction__nav-panel">
          <div class="product-page-instruction__nav-arrow" onclick={() => {
            this.scrollTo(this.currentInstructionIndex - 1)
          }}
          >
            <ArrowNavSvg />
          </div>
          <div class="product-page-instruction__nav-panel-title">
            {this.propertyList[this.currentInstructionIndex].title}
          </div>
          <div class="product-page-instruction__nav-arrow" onclick={() => {
            this.scrollTo(this.currentInstructionIndex + 1)
          }}
          >
            <ArrowNavSvg />
          </div>
        </div>
        <div class="product-page-instruction__nav-list">
          {this.propertyList.map((item: ProductDetailProperty, index: number) => {
            return (
              <div class="product-page-instruction__nav-item" onClick={() => this.scrollTo(index)}>
                {item.title}
              </div>
            )
          })}
        </div>
      </div>)
  }

  render () {
    return (
      <div class="product-page-instruction">
        <div class="product-page-instruction__row">
          <div class="product-page-instruction__col-nav">
            {this.propertyList.length >= 2 && this.renderNavigation()}
          </div>
          <div class="product-page-instruction__col-content">
            {this.propertyList.map((item:ProductDetailProperty, index:number) => this.renderItem(item, index))}
          </div>
        </div>
      </div>
    )
  }
}
